import { render, staticRenderFns } from "./EmploymentList.vue?vue&type=template&id=4a2c0e70&scoped=true&"
import script from "./EmploymentList.vue?vue&type=script&lang=js&"
export * from "./EmploymentList.vue?vue&type=script&lang=js&"
import style0 from "./EmploymentList.vue?vue&type=style&index=0&id=4a2c0e70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2c0e70",
  null
  
)

export default component.exports